import * as Yup from 'yup';
import i18next from '../i18n';

export const referralEmailValidationSchema = Yup.object({
  emails: Yup.array()
    .of(
      Yup.string()
        .required(i18next.t('validationSchema.general.emailRequired'))
        .email(i18next.t('validationSchema.general.emailRequired')),
    )
    .min(1, i18next.t('validationSchema.general.emailRequired')),
});
